var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAhLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1080 1080",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.349 50.4157L508.45 137.077L508.45 310.398L358.349 397.059L208.248 310.398L208.248 137.077L358.349 50.4157Z",
    fill: "none",
    opacity: 1,
    stroke: "#a5a5a5",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.698 50.4157L872.799 137.077L872.799 310.398L722.698 397.059L572.597 310.398L572.597 137.077L722.698 50.4157Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.698 683.218L872.799 769.879L872.799 943.201L722.698 1029.86L572.597 943.201L572.597 769.879L722.698 683.218Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.349 683.218L508.45 769.879L508.45 943.201L358.349 1029.86L208.248 943.201L208.248 769.879L358.349 683.218Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540 366.678L690.101 453.339L690.101 626.661L540 713.322L389.899 626.661L389.899 453.339L540 366.678Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.648 366.678L1053.75 453.339L1053.75 626.661L903.648 713.322L753.547 626.661L753.547 453.339L903.648 366.678Z",
    fill: "none",
    opacity: 1,
    stroke: "#a5a5a5",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.753 366.678L326.854 453.339L326.854 626.661L176.753 713.322L26.6516 626.661L26.6516 453.339L176.753 366.678Z",
    fill: "none",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 27.9551
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhLogo);
export default __webpack_public_path__ + "static/media/ah_logo.d9c30dfd1775b9fd072f6d2760f0e141.svg";
export { ForwardRef as ReactComponent };